<ng-container *ngIf="profileField$ | async as profileField">
    <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term" style="{{ nestedPadding$ | async }}">{{ profileField.DisplayLabel }}</dt>
    <dd class="sh-description-list__details">{{ 'form.error.unsupported-field' | translate:{type: profileField.FieldDefinition.Type} }}</dd>
</ng-container>
